import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { SourceRange } from "../../text/lexer/parsing/SourceInfo";
import { RJParser } from "../RJParser";
import { RJExpressionNode } from "./RJExpressionNode";
import { RJExpressionNodeType } from "./RJExpressionNodeType";


export class ConstantExpression<T> extends RJExpressionNode
{
  protected _value:T;
  get value():T{ return this._value;}
  protected _constantType:string;

  constructor( parser:RJParser, range:SourceRange = null )
  {
    super( parser, RJExpressionNodeType.CONSTANT, range );
  }

  setConstant( type:string, value:T )
  {
    this._constantType = type;
    this._value = value;
  }

  cloneNode():ConstantExpression<T>
  {
    let clone = new ConstantExpression<T>( this.parser, this.sourceRange );
    this._copyExpressionNodeData( clone );
    clone.setConstant( this._constantType, this._value );
    return clone;
  }

  static readonly constantTypeAttribute = new ElementAttribute( "constant-type" );

  createHTMLElement():Element
  {   
    let element = this._createRawHTMLElement();

    ConstantExpression.constantTypeAttribute.to( element, this._constantType );

    element.appendChild( document.createTextNode( this._value + "" ) );

    return element;
  }
}